import React,{useState,useEffect } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/button';
import { useHistory } from "react-router-dom";
import '../resources/css/login/login.css';
import '../resources/RTCC/css/common/common.css'
import messageConst from '../const/messageConst';
import Const from '../const/Const';

export const MemberShipImportedCheck = (props) => {
    const {
        state,
        setKaiinkenFlg
    } = props;

    const history = useHistory();
    const kaiinkenFlg = state.kaiinkenFlg;
    const store = useStore();

    //画面読み込み時に1度だけしか実行させない
    useEffect(() => {
        // const state = store.getState().login;
        // const memberInfo = state?.memberInfo;
        // if (Object.keys(state).length === 0 || !memberInfo) {
        //     setKaiinkenFlg(true);
        //     return;
        // }
        // let messageFlg = true;
        // memberInfo?.forEach(member => {
        //     member?.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
        //         if (kaiinInfo?.bccKeiyakuKbn != 1 && kaiinInfo?.kaihiMinoKbn != 1) {
        //             messageFlg = false;
        //             return;
        //         }
        //     })
        //     if (!messageFlg) {
        //         return;
        //     }
        // });
        // setKaiinkenFlg(messageFlg);
    }, []);

    //ログアウト処理
    const logoutClick= () => {
        history.push("/reserve/top");
    };

    // OK押下処理
    const onClickOk= () => {
        setKaiinkenFlg(false);
    };
    
    return (
        <div>
            {kaiinkenFlg ?
                <div className='modalBody'>
                    <div className='modalContent'>
                        <div className='modalArea'>
                            <div>
                                <div className='modalText'>{messageConst.RESTAURANT_KAIINKEN_ERROR}</div>
                                <div className='modalBtnArea'>
                                    <Button
                                        onClick={onClickOk}
                                        buttonText={"OK"}
                                        className="logoutBtn"
                                    />
                                    {/* <Button
                                        onClick={logoutClick}
                                        buttonText={"TOP画面へ"}
                                        className="logoutBtn"
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    )
}